module.exports = __webpack_public_path__ + "static/media/FR-67.50a0385c.geojson";